import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IActiveJourney, IGetAllJourneys } from '../../actions/types/sources/GetAllJourneys';

/**
 * Initial All Joureny state in store
 */
const initialState: IGetAllJourneys = {
  isLoading: false,
  statusCode: '',
  listJourneyErrorMessage: '',
  journeyData: {
    totalJourneysCount: 0,
    journeyList: []
  }
};

const fetchJourneysListSlice = createSlice({
  name: 'fetchJourneysList',
  initialState,
  reducers: {
    fetchJourneysListStarted: (state) => {
      state.isLoading = true;
    },

    fetchJourneysListSuccess: (
      state,
      action: PayloadAction<{ journeyList: IActiveJourney, statusCode: string }>
    ) => {
      state.isLoading = false;
      state.journeyData = action.payload.journeyList;
      state.statusCode = action.payload.statusCode;
      state.listJourneyErrorMessage = '';
    },

    fetchJourneysListFail: (state, action: PayloadAction<{ error: string, statusCode: string }>) => {
      state.isLoading = false;
      state.journeyData = initialState.journeyData;
      state.statusCode = action.payload.statusCode;
      state.listJourneyErrorMessage = action.payload.error;
    },

    clearJourneysListDetails: (state) => {
      state.isLoading = false;
      state.journeyData = initialState.journeyData;
      state.listJourneyErrorMessage = '';
    }
  }
});
export const {
  fetchJourneysListStarted,
  fetchJourneysListSuccess,
  fetchJourneysListFail,
  clearJourneysListDetails
} = fetchJourneysListSlice.actions;
export default fetchJourneysListSlice.reducer;
